import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '@g99-product-web-ui/shared-service';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  constructor(private readonly _httpService: HttpService) {}

  public fetchBusinessProfile(token: string, bid: string): Observable<any> {
    const url = API_ENDPOINTS.BUSINESS_ENDPOINTS.businesses(bid);

    const headers = new HttpHeaders({
      'X-TenantID': String(bid), // Use the token as needed
    });

    // Utilize the HttpService's get method
    return this._httpService.get<any>(url, {
      params: {} as HttpParams,
      headers,
      attachTenantId: false,
    });
  }
}
